export default "__VITE_ASSET__mxh_gbt4__"